const state = () => ({
    sourceSearch: '',
    requestingAgency: '',
    enabledReordering: false,
    enabledOnlyReordering: false,
    sourceSearchSelected: '',
    showSelectSourceList: false,
    enabledConvalescence: false,
    previousPage: 'login',
    packageVersion: process.env.PACKAGE_VERSION || '0'
});
  

const getters = {
    getSourceSearch: state =>{
      return state.sourceSearch;
    },    
    getRequestingAgency: state =>{
        return state.requestingAgency;
    },
    getEnabledReordering: state =>{
        return state.enabledReordering;
    },   
    getEnabledOnlyReordering: state =>{
        return state.enabledOnlyReordering;
    },  
    getSourceSearchSelected: state =>{
        return state.sourceSearchSelected;
    },
    getEnabledConvalescence: state =>{
        return state.enabledConvalescence;
    },
    getPreviousPage: state => {
        return state.previousPage;
    },
    appVersion: (state) => {
        return state.packageVersion;
    }
};

const mutations = {
    updateSourceSearch: (state, sourceSearch) => {
       state.sourceSearch = sourceSearch;
    },
    updateRequestingAgency: (state, requestingAgency) => {
        state.requestingAgency = requestingAgency;
     },
     updateEnabledReordering: (state, enabledReordering) => {
        console.log('A 2 enabledReordering',enabledReordering);
        state.enabledReordering = enabledReordering;
    },
    updateEnabledOnlyReordering: (state,  enabledOnlyReordering) => {
        console.log('A 1 enableOnlyReordering',enabledOnlyReordering);
        console.log('A 1 state',state.getSourceSearchSelected);
        state.enabledOnlyReordering = enabledOnlyReordering;
    },
    updateSourceSearchSelected: (state, sourceSearchSelected) => {
        state.sourceSearchSelected = sourceSearchSelected;
    },
    updateEnabledConvalescence: (state, enabledConvalescence) => {
        state.enabledConvalescence = enabledConvalescence;
    },
    updatePreviousPage: (state, previousPage) => {
        state.previousPage = previousPage;
    }
    
};

const actions = {
    setSourceSearch: async({commit}, value) => {
        commit('updateSourceSearch', value);
    },  
    setRequestingAgency: async ({commit}, value) => {
      commit('updateRequestingAgency', value);
    },  
    setEnabledReordering: async({commit}, value) => {
        commit('updateEnabledReordering', value);
    },
    setEnabledOnlyReordering: async({commit}, value) => {
        commit('updateEnabledOnlyReordering', value);
    },
    setSourceSearchSelected: async({commit}, value) => {
        commit('updateSourceSearchSelected', value);
    },
    setEnabledConvalescence: async({commit}, value) => {
        commit('updateEnabledConvalescence', value);
    },
    setPreviousPage: async ({ commit }, value) => {
        commit('updatePreviousPage', value);
    }
    
};
  
export default {
    namespaced:true,
    state,
    getters,
    mutations,
    actions
};